import { SessionStorageService } from 'ngx-webstorage';
import { ErrorHandlingService } from '../../services/error-handling/error-handling.service';
import { HttpService } from '../../services/http/http.service';
import { Component, OnInit } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { SessionKeys } from 'src/app/shared/enums/session-keys.enum';

@Component({
  selector: 'app-login-main',
  standalone: true,
  templateUrl: './login-main.component.html',
  styleUrls: ['./login-main.component.css'],
  imports: [LoginComponent, NgxSpinnerModule, CommonModule, ReactiveFormsModule],
})
export class LoginMainComponent implements OnInit
{

  bln_loading: boolean = false;
  bln_isLadp: boolean = false;
  str_authenticationType!: string;
  SystemAuthenticationType = '';

  constructor(private http: HttpService, private errorHandling: ErrorHandlingService,
     private sessionStorage: SessionStorageService) {
      console.log('navigated');
      
      }

  ngOnInit()
  {
    this.bln_loading = true;
      this.http.getMethod("systemPrechecks/getSystemPrechecks").subscribe({

        next: (v:any) => {
          this.bln_loading = false;
          if (v === null || v === undefined) {
            this.errorHandling.checkError(500);
            return;
          }
          this.str_authenticationType=v.SystemAuthenticationType?.trim().toUpperCase();
          console.log(this.str_authenticationType);
          this.sessionStorage?.store(SessionKeys.TimeDate,v.TimeDate);
          console.log(v);
        },
        error: (err:any) => {
          this.errorHandling.checkError(err.status);
          this.bln_loading = false;
         },
      })
    }
}
